// import React, { useState, useEffect, useRef } from 'react';

// const PlanToolbar = ({
//   searchQuery, setSearchQuery,
//   selectedBrands, setSelectedBrands,
//   selectedNiches, setSelectedNiches,
//   brands, niches,
//   filteredCount, totalCount,
//   hasActiveFilters, clearFilters,
//   activeTab,
//   weeklyDateRange, setWeeklyDateRange,
// }) => {
//   const [brandOpen, setBrandOpen] = useState(false);
//   const [nicheOpen, setNicheOpen] = useState(false);
//   const [dateOpen, setDateOpen] = useState(false);
//   const brandRef = useRef(null);
//   const nicheRef = useRef(null);
//   const dateRef = useRef(null);

//   // Current year weeks for date picker
//   const currentYear = new Date().getFullYear();

//   useEffect(() => {
//     const handleOut = (e) => {
//       if (brandRef.current && !brandRef.current.contains(e.target)) setBrandOpen(false);
//       if (nicheRef.current && !nicheRef.current.contains(e.target)) setNicheOpen(false);
//       if (dateRef.current && !dateRef.current.contains(e.target)) setDateOpen(false);
//     };
//     document.addEventListener('mousedown', handleOut);
//     return () => document.removeEventListener('mousedown', handleOut);
//   }, []);

//   const toggleBrand = (id) => {
//     setSelectedBrands(prev => prev.includes(id) ? prev.filter(b => b !== id) : [...prev, id]);
//   };
//   const toggleNiche = (id) => {
//     setSelectedNiches(prev => prev.includes(id) ? prev.filter(n => n !== id) : [...prev, id]);
//   };

//   // Generate weeks for current year.
//   // W1 = the ISO week that contains Jan 1 (Monday may be in Dec of prev year).
//   const getWeeksOfYear = (year) => {
//     const weeks = [];
//     // Start from Jan 1 and walk back to the nearest Monday
//     let d = new Date(year, 0, 1);
//     const dow = d.getDay(); // 0=Sun, 1=Mon … 6=Sat
//     const backDays = dow === 0 ? 6 : dow - 1; // days to subtract to reach Monday
//     d.setDate(d.getDate() - backDays);
//     // d is now the Monday of the week containing Jan 1
//     while (true) {
//       const start = new Date(d);
//       const end = new Date(d);
//       end.setDate(end.getDate() + 6);
//       // Stop once the week's Monday is past Dec 31 of the year
//       if (start.getFullYear() > year && start.getMonth() > 0) break;
//       // Also stop if this whole week is already in the next year (Mon is Jan of next year)
//       if (start.getFullYear() > year) break;
//       weeks.push({ start: new Date(start), end: new Date(end) });
//       d.setDate(d.getDate() + 7);
//     }
//     return weeks;
//   };

//   const weeks = getWeeksOfYear(currentYear);

//   const fmt = (date) => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
//   const fmtFull = (date) => date.toISOString().split('T')[0];

//   const selectedWeekLabel = weeklyDateRange
//     ? `${fmt(new Date(weeklyDateRange.start))} – ${fmt(new Date(weeklyDateRange.end))}`
//     : 'All weeks';

//   return (
//     <div className="ptp-toolbar">
//       {/* Search */}
//       <div className="ptp-search-wrapper">
//         <i className="fas fa-search ptp-search-icon"></i>
//         <input
//           type="text"
//           className="ptp-search-input"
//           placeholder="Search by name, SKU or ASIN…"
//           value={searchQuery}
//           onChange={e => setSearchQuery(e.target.value)}
//         />
//         {searchQuery && (
//           <button className="ptp-search-clear" onClick={() => setSearchQuery('')}>
//             <i className="fas fa-times"></i>
//           </button>
//         )}
//       </div>

//       {/* Brand filter */}
//       <div className="ptp-filter-wrapper" ref={brandRef}>
//         <button
//           className={`ptp-filter-btn${selectedBrands.length > 0 ? ' active' : ''}`}
//           onClick={() => { setBrandOpen(o => !o); setNicheOpen(false); setDateOpen(false); }}
//         >
//           <i className="fas fa-tag"></i>
//           Brand
//           {selectedBrands.length > 0 && <span className="ptp-filter-badge">{selectedBrands.length}</span>}
//           <i className={`fas fa-chevron-${brandOpen ? 'up' : 'down'} ptp-chevron`}></i>
//         </button>
//         {brandOpen && (
//           <div className="ptp-dropdown">
//             <div className="ptp-dropdown-header">Filter by Brand</div>
//             {brands.length === 0 ? (
//               <div className="ptp-dropdown-empty">No brands</div>
//             ) : brands.map(b => (
//               <label key={b.brandID} className="ptp-dropdown-option">
//                 <input
//                   type="checkbox"
//                   checked={selectedBrands.includes(String(b.brandID))}
//                   onChange={() => toggleBrand(String(b.brandID))}
//                 />
//                 {b.brandName || b.brandID}
//               </label>
//             ))}
//             {selectedBrands.length > 0 && (
//               <button className="ptp-dropdown-clear" onClick={() => setSelectedBrands([])}>Clear</button>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Niche filter */}
//       <div className="ptp-filter-wrapper" ref={nicheRef}>
//         <button
//           className={`ptp-filter-btn${selectedNiches.length > 0 ? ' active' : ''}`}
//           onClick={() => { setNicheOpen(o => !o); setBrandOpen(false); setDateOpen(false); }}
//         >
//           <i className="fas fa-layer-group"></i>
//           Niche
//           {selectedNiches.length > 0 && <span className="ptp-filter-badge">{selectedNiches.length}</span>}
//           <i className={`fas fa-chevron-${nicheOpen ? 'up' : 'down'} ptp-chevron`}></i>
//         </button>
//         {nicheOpen && (
//           <div className="ptp-dropdown">
//             <div className="ptp-dropdown-header">Filter by Niche</div>
//             {niches.length === 0 ? (
//               <div className="ptp-dropdown-empty">No niches</div>
//             ) : niches.map(n => (
//               <label key={n.niche_category_id} className="ptp-dropdown-option">
//                 <input
//                   type="checkbox"
//                   checked={selectedNiches.includes(String(n.niche_category_id))}
//                   onChange={() => toggleNiche(String(n.niche_category_id))}
//                 />
//                 {n.niche_name}
//               </label>
//             ))}
//             {selectedNiches.length > 0 && (
//               <button className="ptp-dropdown-clear" onClick={() => setSelectedNiches([])}>Clear</button>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Date range picker — only for weekly tab */}
//       {activeTab === 'weekly' && (
//         <div className="ptp-filter-wrapper" ref={dateRef}>
//           <button
//             className={`ptp-filter-btn${weeklyDateRange ? ' active' : ''}`}
//             onClick={() => { setDateOpen(o => !o); setBrandOpen(false); setNicheOpen(false); }}
//           >
//             <i className="fas fa-calendar"></i>
//             {selectedWeekLabel}
//             <i className={`fas fa-chevron-${dateOpen ? 'up' : 'down'} ptp-chevron`}></i>
//           </button>
//           {dateOpen && (
//             <div className="ptp-dropdown ptp-dropdown--weeks">
//               <div className="ptp-dropdown-header">Select week range</div>
//               <button
//                 className={`ptp-week-option${!weeklyDateRange ? ' selected' : ''}`}
//                 onClick={() => { setWeeklyDateRange(null); setDateOpen(false); }}
//               >
//                 Show all weeks
//               </button>
//               {weeks.map((w, i) => {
//                 const key = fmtFull(w.start);
//                 const isSelected = weeklyDateRange?.start === fmtFull(w.start);
//                 return (
//                   <button
//                     key={key}
//                     className={`ptp-week-option${isSelected ? ' selected' : ''}`}
//                     onClick={() => {
//                       setWeeklyDateRange({ start: fmtFull(w.start), end: fmtFull(w.end) });
//                       setDateOpen(false);
//                     }}
//                   >
//                     <span className="ptp-week-num">W{i + 1}</span>
//                     <span>{fmt(w.start)} – {fmt(w.end)}</span>
//                   </button>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       )}

//       {/* Results info */}
//       <div className="ptp-results-info">
//         <span className="ptp-results-count">{filteredCount} of {totalCount} products</span>
//         {hasActiveFilters && (
//           <button className="ptp-clear-all" onClick={clearFilters}>
//             <i className="fas fa-times-circle"></i> Clear all
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PlanToolbar;

import React, { useState, useEffect, useRef } from 'react';
import { toMiamiDateString, formatMiamiShort, getMiamiWeeksOfYear, getCurrentMiamiWeekRange } from '../utils/dateUtils';

const PlanToolbar = ({
  searchQuery, setSearchQuery,
  selectedBrands, setSelectedBrands,
  selectedNiches, setSelectedNiches,
  brands, niches,
  filteredCount, totalCount,
  hasActiveFilters, clearFilters,
  activeTab,
  weeklyDateRange, setWeeklyDateRange,
}) => {
  const [brandOpen, setBrandOpen] = useState(false);
  const [nicheOpen, setNicheOpen] = useState(false);
  const [dateOpen, setDateOpen] = useState(false);
  const [rangeFrom, setRangeFrom] = useState('');
  const [rangeTo, setRangeTo]     = useState('');
  const brandRef = useRef(null);
  const nicheRef = useRef(null);
  const dateRef  = useRef(null);

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const handleOut = (e) => {
      if (brandRef.current && !brandRef.current.contains(e.target)) setBrandOpen(false);
      if (nicheRef.current && !nicheRef.current.contains(e.target)) setNicheOpen(false);
      if (dateRef.current && !dateRef.current.contains(e.target)) setDateOpen(false);
    };
    document.addEventListener('mousedown', handleOut);
    return () => document.removeEventListener('mousedown', handleOut);
  }, []);

  const toggleBrand = (id) => {
    setSelectedBrands(prev => prev.includes(id) ? prev.filter(b => b !== id) : [...prev, id]);
  };

  const toggleNiche = (id) => {
    setSelectedNiches(prev => prev.includes(id) ? prev.filter(n => n !== id) : [...prev, id]);
  };

  const weeks = getMiamiWeeksOfYear(currentYear);

  const todayStr = toMiamiDateString(new Date());
  const currentWeekIdx = weeks.findIndex(w =>
    toMiamiDateString(w.start) <= todayStr && toMiamiDateString(w.end) >= todayStr
  );

  const handleOpenDate = () => {
    if (weeklyDateRange) {
      const fromIdx = weeks.findIndex(w => toMiamiDateString(w.start) === weeklyDateRange.start);
      const toIdx   = weeks.findIndex(w => toMiamiDateString(w.end)   === weeklyDateRange.end);
      setRangeFrom(fromIdx >= 0 ? String(fromIdx) : '');
      setRangeTo(toIdx   >= 0 ? String(toIdx)   : '');
    } else {
      setRangeFrom('');
      setRangeTo('');
    }
    setDateOpen(o => !o);
    setBrandOpen(false);
    setNicheOpen(false);
  };

  const applyRange = () => {
    if (rangeFrom === '' && rangeTo === '') {
      setWeeklyDateRange(null);
    } else {
      const fi = rangeFrom !== '' ? Number(rangeFrom) : Number(rangeTo);
      const ti = rangeTo   !== '' ? Number(rangeTo)   : Number(rangeFrom);
      const lo = Math.min(fi, ti);
      const hi = Math.max(fi, ti);
      setWeeklyDateRange({
        start: toMiamiDateString(weeks[lo].start),
        end:   toMiamiDateString(weeks[hi].end),
      });
    }
    setDateOpen(false);
  };

  // Label for the date picker button
  let selectedWeekLabel = 'All weeks';
  if (weeklyDateRange) {
    const fromIdx = weeks.findIndex(w => toMiamiDateString(w.start) === weeklyDateRange.start);
    const toIdx   = weeks.findIndex(w => toMiamiDateString(w.end)   === weeklyDateRange.end);
    if (fromIdx >= 0 && toIdx >= 0 && fromIdx === toIdx) {
      selectedWeekLabel = `W${fromIdx + 1}: ${formatMiamiShort(weeks[fromIdx].start)} – ${formatMiamiShort(weeks[fromIdx].end)}`;
    } else if (fromIdx >= 0 && toIdx >= 0) {
      selectedWeekLabel = `W${fromIdx + 1} – W${toIdx + 1}`;
    } else {
      selectedWeekLabel = `${weeklyDateRange.start} – ${weeklyDateRange.end}`;
    }
  }

  return (
    <div className="ptp-toolbar">
      {/* Search */}
      <div className="ptp-search-wrapper">
        <i className="fas fa-search ptp-search-icon"></i>
        <input
          type="text"
          className="ptp-search-input"
          placeholder="Search by name, SKU or ASIN…"
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
        />
        {searchQuery && (
          <button className="ptp-search-clear" onClick={() => setSearchQuery('')}>
            <i className="fas fa-times"></i>
          </button>
        )}
      </div>

      {/* Brand filter */}
      <div className="ptp-filter-wrapper" ref={brandRef}>
        <button
          className={`ptp-filter-btn${selectedBrands.length > 0 ? ' active' : ''}`}
          onClick={() => { setBrandOpen(o => !o); setNicheOpen(false); setDateOpen(false); }}
        >
          <i className="fas fa-tag"></i>
          Brand
          {selectedBrands.length > 0 && <span className="ptp-filter-badge">{selectedBrands.length}</span>}
          <i className={`fas fa-chevron-${brandOpen ? 'up' : 'down'} ptp-chevron`}></i>
        </button>
        {brandOpen && (
          <div className="ptp-dropdown">
            <div className="ptp-dropdown-header">Filter by Brand</div>
            {brands.length === 0 ? (
              <div className="ptp-dropdown-empty">No brands</div>
            ) : brands.map(b => (
              <label key={b.brandID} className="ptp-dropdown-option">
                <input
                  type="checkbox"
                  checked={selectedBrands.includes(String(b.brandID))}
                  onChange={() => toggleBrand(String(b.brandID))}
                />
                {b.brandName || b.brandID}
              </label>
            ))}
            {selectedBrands.length > 0 && (
              <button className="ptp-dropdown-clear" onClick={() => setSelectedBrands([])}>Clear</button>
            )}
          </div>
        )}
      </div>

      {/* Niche filter */}
      <div className="ptp-filter-wrapper" ref={nicheRef}>
        <button
          className={`ptp-filter-btn${selectedNiches.length > 0 ? ' active' : ''}`}
          onClick={() => { setNicheOpen(o => !o); setBrandOpen(false); setDateOpen(false); }}
        >
          <i className="fas fa-layer-group"></i>
          Niche
          {selectedNiches.length > 0 && <span className="ptp-filter-badge">{selectedNiches.length}</span>}
          <i className={`fas fa-chevron-${nicheOpen ? 'up' : 'down'} ptp-chevron`}></i>
        </button>
        {nicheOpen && (
          <div className="ptp-dropdown">
            <div className="ptp-dropdown-header">Filter by Niche</div>
            {niches.length === 0 ? (
              <div className="ptp-dropdown-empty">No niches</div>
            ) : niches.map(n => (
              <label key={n.niche_category_id} className="ptp-dropdown-option">
                <input
                  type="checkbox"
                  checked={selectedNiches.includes(String(n.niche_category_id))}
                  onChange={() => toggleNiche(String(n.niche_category_id))}
                />
                {n.niche_name}
              </label>
            ))}
            {selectedNiches.length > 0 && (
              <button className="ptp-dropdown-clear" onClick={() => setSelectedNiches([])}>Clear</button>
            )}
          </div>
        )}
      </div>

      {/* Date range picker — only for weekly tab */}
      {activeTab === 'weekly' && (
        <div className="ptp-filter-wrapper" ref={dateRef}>
          <button
            className={`ptp-filter-btn${weeklyDateRange ? ' active' : ''}`}
            onClick={handleOpenDate}
          >
            <i className="fas fa-calendar"></i>
            {selectedWeekLabel}
            <i className={`fas fa-chevron-${dateOpen ? 'up' : 'down'} ptp-chevron`}></i>
          </button>
          {dateOpen && (
            <div className="ptp-dropdown ptp-dropdown--weeks">
              <div className="ptp-dropdown-header">Select week range</div>

              {/* Quick actions */}
              <div className="ptp-week-quick-actions">
                {currentWeekIdx >= 0 && (
                  <button
                    className="ptp-week-quick-btn ptp-week-quick-btn--primary"
                    onClick={() => { setWeeklyDateRange(getCurrentMiamiWeekRange()); setDateOpen(false); }}
                  >
                    Current week
                  </button>
                )}
              </div>

              <div className="ptp-dropdown-divider" />

              {/* From / To selects */}
              <div className="ptp-week-range-picker">
                <div className="ptp-week-range-row">
                  <span className="ptp-week-range-label">From:</span>
                  <select
                    className="ptp-week-range-select"
                    value={rangeFrom}
                    onChange={e => setRangeFrom(e.target.value)}
                  >
                    <option value="">—</option>
                    {weeks.map((w, i) => (
                      <option key={i} value={i}>W{i + 1} · {formatMiamiShort(w.start)}</option>
                    ))}
                  </select>
                </div>
                <div className="ptp-week-range-row">
                  <span className="ptp-week-range-label">To:</span>
                  <select
                    className="ptp-week-range-select"
                    value={rangeTo}
                    onChange={e => setRangeTo(e.target.value)}
                  >
                    <option value="">—</option>
                    {weeks.map((w, i) => (
                      <option key={i} value={i}>W{i + 1} · {formatMiamiShort(w.end)}</option>
                    ))}
                  </select>
                </div>
                <button className="ptp-week-range-apply" onClick={applyRange}>Apply</button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Results info */}
      <div className="ptp-results-info">
        <span className="ptp-results-count">{filteredCount} of {totalCount} products</span>
        {hasActiveFilters && (
          <button className="ptp-clear-all" onClick={clearFilters}>
            <i className="fas fa-times-circle"></i> Clear all
          </button>
        )}
      </div>
    </div>
  );
};

export default PlanToolbar;